export const findLongestElement = (list) => {
    let longest = 0;

    for (let element of list) {
        const item = element.querySelector('span');
        if (item.clientWidth > longest) longest = item.clientWidth;
    }

    return longest;
};